var map = {
	"./after_1.jpg": 6160,
	"./after_2.jpg": 9775,
	"./after_3.jpg": 5490,
	"./after_4.jpg": 3505,
	"./before_1.png": 3869,
	"./before_2.png": 2662,
	"./before_3.png": 4207,
	"./before_4.png": 8832,
	"./before_5.png": 5081,
	"./before_6.png": 8498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4539;